"use strict";
/* ========================================================================
    Module: Dropdown redirect
 ========================================================================== */
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropdownRdirect = void 0;
/**
 * ドロップダウンに設定された URL へリダイレクトする
 *
 * @returns void
 */
const dropdownRdirect = () => {
    const dropdownElements = document.querySelectorAll('[name^="archive-dropdown"]');
    if (dropdownElements.length > 0) {
        dropdownElements.forEach((element) => {
            element.addEventListener("change", (e) => {
                if (!(e.currentTarget instanceof HTMLSelectElement)) {
                    return;
                }
                if (e.currentTarget.value) {
                    document.location.href = e.currentTarget.value;
                }
            });
        });
    }
};
exports.dropdownRdirect = dropdownRdirect;
